import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UrlService} from '../url.service';

@Injectable()
export class PlanService {
    private BASE_URL: string;
    private ASSESSMENTS_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/plans';
        this.ASSESSMENTS_URL = this.urlService.getBackendUrl() + 'data/assessments';
    }

    loadPlans(planId) {
      let params = new HttpParams();
      params = params.set('planId', planId);

      const requestOptions = {
        params: params,
      }

      return this.http.get(this.BASE_URL, requestOptions);
    }

    savePlan(plan) {
      return this.http.put(this.BASE_URL, plan);
    }

    createPlan(plan) {
      return this.http.post(this.BASE_URL + '/' + plan.id , plan);
    }

    deletePlan(plan) {
      return this.http.delete(this.BASE_URL + '/' + plan.id);
    }

    getForAssessment(assessmentId) {
      return this.http.get(`${this.ASSESSMENTS_URL}/${assessmentId}/plans`);
    }
}
